import React, { useState, useRef, useEffect } from "react";
import about from "../../assets/image/about_nha_pg_logo.png";
import {
  MobileOTPServices,
  mobileOtpVerifyServices,
  EncryptServices
} from "../../services";
import { useSelector } from "react-redux";
import { timerCount } from "../../config";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const LoginMobileOtpVerify = ({
  setMobileOtp,
  setIsVerifiedOtp,
  mobileNumber,
  setMobileOTPSent,
  setCurrentStep
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [otpGuid, setOtpGuid] = useState("");
  const [displayMobileNumber, setDisplayMobileNumber] = useState("");
  const [timer, setTimer] = useState(timerCount);
  const [resendCount, setResendCount] = useState(2);
  const [disableResend, setDisableResend] = useState(false);
  const uuid = useSelector((state) => state.user.UUid);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (mobileNumber) {
      setDisplayMobileNumber(mobileNumber);
    }
    const savedResponse = localStorage.getItem("otpResponse");
    if (savedResponse) {
      try {
        const response = JSON.parse(savedResponse);
        const guid = response?.data.otpGuid;
        if (guid) {
          setOtpGuid(guid);
        } else {
          setError("No valid OTP session found. Please resend OTP.");
        }
      } catch (error) {
        setError("Failed to load OTP session. Please resend OTP.");
      }
    } else {
      setError("No OTP session found. Please resend OTP.");
    }
  }, [mobileNumber]);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const sendMobileNumber = localStorage.getItem("mobile");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const verificationResponse = await VerifymobileOtp(otpValue);
      const statusMessage = verificationResponse?.message;
      if (verificationResponse?.success === true && verificationResponse?.data.otp_guid) {
        const patientDetails = verificationResponse.data?.patients;
        if (patientDetails && Array.isArray(patientDetails)) {
          localStorage.setItem("patientDetails", JSON.stringify(patientDetails));
        } else {
          localStorage.setItem("patientDetails", JSON.stringify([]));
          Swal.fire({
            title: patientDetails?.length === 0 ? "No Profile Found" : "",
            text: "Do you want to continue to create profile and Link ABHA?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!"
          }).then((result) => {
            if (result.isConfirmed) {
              setCurrentStep("SendAdharOTP");
            }
          });
        }
        setCurrentStep("PatientList");
        localStorage.removeItem("otpResponse");
        setError(null);
      } else {
        toast.error(statusMessage || "OTP verification failed");
      }
    } catch (error) {
      setError("Verification failed. Please enter correct otp.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const VerifymobileOtp = async (otpValue) => {
    try {
      const body = { guid: uuid, otp: otpValue };
      return await mobileOtpVerifyServices({ body });
    } catch (error) {
      console.error("Error while verifying OTP:", error);
      throw error;
    }
  };

  const sendOtp = async () => {
    if (resendCount <= 0 || disableResend) {
      setDisableResend(true);
      setError("You have reached the maximum resend attempts.");
      return;
    }
    setIsLoading(true);
    setError(null);
    const mobile = localStorage.getItem("mobile");
    try {
      const emobile = await EncryptServices({ headers: {}, body: { data: mobile } });
      const body = { mobile: emobile, resent_count: resendCount };
      const response = await MobileOTPServices({ body });
      if (response?.success) {
        const otpData = response.data;
        if (otpData?.otpGuid) {
          setOtpGuid(otpData.otpGuid);
          localStorage.setItem("otpResponse", JSON.stringify(response));
          setOtp(["", "", "", "", "", ""]);
          setResendCount((prev) => {
            const newCount = prev - 1;
            if (otpData.resent_count === 0 || newCount <= 0) {
              setDisableResend(true);
              toast.error("You have reached the maximum resend attempts.");
            } else {
              toast.success(`OTP sent successfully! Attempts left: ${newCount}`);
            }
            return newCount;
          });
          setTimeout(() => setError(null), 5000);
        } else {
          toast.error("OTP sent but technical error occurred");
          localStorage.removeItem("otpResponse");
        }
      } else {
        const errorMessage = response.data?.statusMessage || "Failed to send OTP";
        setError(errorMessage);
        if (response.data?.statusCode === "1") {
          setOtpGuid("");
          localStorage.removeItem("otpResponse");
        }
      }
      setTimer(timerCount);
    } catch (error) {
      setError("Failed to send OTP. Please try again.");
      localStorage.removeItem("otpResponse");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">Ayushman Bharat Digital Mission (ABDM)</span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: OTP Form ── */}
            <div className="col-12 col-md-6">
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">
                  <h3 className="lmop-card-title">Create / Link Your ABHA</h3>
                  <p className="lmop-card-subtitle">
                    Enter OTP received on your number +91 {sendMobileNumber}
                  </p>

                  {error && (
                    <div className={`alert ${error.includes("successfully") ? "alert-success" : "alert-danger"}`}>
                      {error}
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="pt-2">
                    {/* OTP Boxes */}
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: "18px" }}>
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          placeholder="0"
                          autoComplete="off"
                          value={digit}
                          ref={(el) => (inputRefs.current[index] = el)}
                          onChange={(e) => handleInputChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          disabled={isLoading}
                          style={{
                            width: "44px",
                            height: "50px",
                            textAlign: "center",
                            fontSize: "1.2rem",
                            fontWeight: "700",
                            border: "1.5px solid #e2e5ec",
                            borderRadius: "10px",
                            background: "#f5f6f8",
                            outline: "none",
                            fontFamily: "Manrope, sans-serif",
                            color: "#222",
                          }}
                        />
                      ))}
                    </div>

                    <button
                      type="submit"
                      className={`lmop-continue-btn ${isLoading || otp.join("").length !== 6 ? "bg-disable" : ""}`}
                      disabled={isLoading || otp.join("").length !== 6}
                    >
                      {isLoading ? "Verifying..." : "Continue"}
                    </button>

                    <p style={{ textAlign: "center", marginTop: "14px", fontSize: "0.85rem", color: "#555" }}>
                      Didn't receive OTP?{" "}
                      {!disableResend && resendCount > 0 && timer > 0 ? (
                        <span style={{ color: "#1a7fff", fontWeight: "600" }}>Resend in {timer}s</span>
                      ) : (
                        <button
                          type="button"
                          onClick={sendOtp}
                          disabled={isLoading || disableResend}
                          style={{
                            background: "none",
                            border: "none",
                            color: disableResend ? "#aaa" : "#1a7fff",
                            fontWeight: "600",
                            cursor: disableResend ? "not-allowed" : "pointer",
                            fontFamily: "Manrope, sans-serif",
                            fontSize: "0.85rem",
                            padding: 0,
                          }}
                        >
                          Resend OTP
                        </button>
                      )}
                    </p>

                    {!disableResend && resendCount > 0 && (
                      <p style={{ textAlign: "center", fontSize: "0.78rem", color: "#888" }}>
                        You have {resendCount} resend attempt{resendCount > 1 ? "s" : ""} left.
                      </p>
                    )}
                    {disableResend && (
                      <p style={{ textAlign: "center", fontSize: "0.78rem", color: "#cf1f1f" }}>
                        You have no resend attempts left.
                      </p>
                    )}
                  </form>

                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default LoginMobileOtpVerify;